<template>
  <div class="develop-container">

    <aside class="develop-sidebar">
      <div class="sidebar-inner" :style="sidebarStyle">
          <div class="version-inline">
            <span class="version-label">版本:</span>
            <el-select
              size="mini"
              v-model="selectedVersion"
              placeholder=""
              @change="handleVersionChange"
            >
              <el-option
                v-for="item in versions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-menu
            ref="sidebarMenu"
            :default-active="activeMenuIndex"
            :default-openeds="propList"
            class="el-menu-vertical-demo sidebar-menu"
            :unique-opened="true"
            @select="
              (key, keyPath) => handleSelect(key, keyPath, selectedVersion)
            "
            @open="handleOpen"
            @close="handleClose"
          >
            <el-submenu
              v-for="(item, index) in menuItems[selectedVersion]"
              :key="`${selectedVersion}-${index}`"
              :index="`${index + 1}`"
            >
              <template slot="title">
                <img v-if="item.icon" :src="item.icon" alt="" class="module-icon" />
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group
                v-for="(itemGroup, groupIndex) in item.children"
                :key="groupIndex"
              >
                <el-menu-item :index="`${index + 1}-${groupIndex}`">
                  <el-tooltip
                    :disabled="!hasMenuItemTip(itemGroup)"
                    placement="right"
                    popper-class="menu-item-tooltip"
                  >
                    <template slot="content">
                      <div
                        v-if="
                          itemGroup.tipContent && itemGroup.tipContent.title
                        "
                      >
                        {{ itemGroup.tipContent.title }}
                        
                      </div>
                      <div
                        v-if="itemGroup.tipContent && itemGroup.tipContent.api"
                        class="menu-tip-api"
                      >
                        {{ itemGroup.tipContent.api }}
                      </div>
                    </template>
                    <div class="menu-item-content">
                      <img
                        v-if="itemGroup.icon"
                        :src="itemGroup.icon"
                        alt=""
                        class="menu-item-icon"
                      />
                      {{ itemGroup.title }}
                      <img  v-if="itemGroup.tipContent && itemGroup.tipContent.title" src="@/assets/icon/tip2.svg" alt="" style="margin-left: 6px;width: 14px;height: 14px;" />
                    </div>
                  </el-tooltip>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
      </div>
    </aside>
    <div class="develop-content">
      <div class="develop-main">
        <router-view></router-view>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import Footer from "@/components/tabbar/footer.vue";
import userIcon from "@/assets/icon/user.svg";
import orderIcon from "@/assets/icon/order.svg";
import centerIcon from "@/assets/icon/center.svg";
import carIcon from "@/assets/icon/car.svg";

export default {
  name: "developmentDocking",
  data() {
    return {
      searchQuery: "",
      selectedVersion: "V1.0",
      sidebarTop: 0,
      sidebarRafId: null,
      versions: [
        // { value: 'next', label: 'Next', tag: '' },
        // { value: '3.9', label: '3.9', tag: 'LATEST' },
        // { value: '3.8', label: '3.8', tag: '' },
        // { value: '3.7', label: '3.7', tag: '' },
        // { value: '3.6', label: '3.6', tag: '' },
        { value: "V1.0", label: "V1.0", tag: "" },

        { value: "oldSystem", label: "老系统（兼容版本）", tag: "" },
      ],
      code: `{
        "shipment": {
          "service": "B2B",
          "store_id": "",
          "client_reference": "",
          "parcel_count": 2,
          "export_scc": 0,
          "import_scc": 0,
          "attrs": []
        }
      }`,
      menuItems: {
        "V1.0": [
          {
            name: "账户模块",
            icon: centerIcon,
            children: [{ title: "账户验证", index: "1" }],
          },
          {
            name: "订单模块",
            icon: orderIcon,
            children: [
              {
                title: "创建订单",
                index: "1",
                tipContent: {
                  title: "下单",
                  api: "/v1/order/aafOrder/createOrder",
                },
              },
              {
                title: "根据订单号获取订单详情",
                index: "3",
                tipContent: {
                  title:
                    "货代标/报关资料对接/清关资料对接/计费重/物流跟踪单号/子单号",
                  api: "/v1/order/aafOrder/queryOrderInfoByOrderNo",
                },
              },
              { title: "获取渠道信息", index: "4" },
              { title: "VAT号带搜索条件下拉", index: "9" },
              // { title: '获取交货仓库信息', index: '8' },
              { title: "获取FBA仓库编码", index: "5" },
              {
                title: "获取订单轨迹",
                index: "6",
                tipContent: {
                  title: "运输轨迹",
                  api: "/v1/track/aafOrderTrack/getTrackInfo",
                },
              },
              // { title: '获取第三方海外信息', index: '7' },
              { title: "取消订单", index: "2" },
              {
                title: "订单文件上传（文件流）",
                index: "10",
                tipContent: {
                  title: "代替客户在客户端上传订单文件",
                  api: "/v1/order/open/aafOrder/uploadOrderFile",
                },
              },
              {
                title: "订单文件上传（文件地址）",
                index: "11",
                tipContent: {
                  title: "文件已在公网时直接绑定订单",
                  api: "/v1/order/open/aafOrder/uploadOrderFileByUrl",
                },
              },
              {
                title: "获取入仓仓库列表",
                index: "12",
                tipContent: {
                  title: "入仓单可选择的收货仓库",
                  api: "/v1/warehouse/open/bdWarehouse/queryWarehouseList",
                },
              },
              {
                title: "下载入仓单",
                index: "13",
                tipContent: {
                  title: "按订单号批量获取入仓交接单",
                  api: "/v1/order/open/aafOrder/entryReceipt/download",
                },
              },
              // { title: '系统状态', index: '2' },
              // { title: '配置选项', index: '3' },
              // { title: '用户管理', index: '4' },
              // { title: '日志', index: '5' }
            ],
          },

          // {
          //   "小妹妹": [
          //     { title: '嘿嘿嘿', index: '1' },
          //     { title: '系统状态', index: '2' },
          //     { title: '配置选项', index: '3' },
          //     { title: '用户管理', index: '4' },
          //     { title: '日志', index: '5' }
          //   ]
          // }
        ],
        oldSystem: [
          {
            name: "运单模块",
            icon: carIcon,
            children: [{ title: "创建运单", index: "1" }],
          },

          // {
          //   "hhh": [
          //     { title: '来玩呀', index: '1' },
          //     { title: '系统状态', index: '2' },
          //     { title: '配置选项', index: '3' },
          //     { title: '用户管理', index: '4' },
          //     { title: '日志', index: '5' }
          //   ]
          // },
          // {
          //   "小妹妹": [
          //     { title: '嘿嘿嘿', index: '1' },
          //     { title: '系统状态', index: '2' },
          //     { title: '配置选项', index: '3' },
          //     { title: '用户管理', index: '4' },
          //     { title: '日志', index: '5' }
          //   ]
          // }
        ],
        // "3.5": [
        //   {
        //     "asa": [
        //       { title: '概览', index: '1' },
        //       { title: '系统状态', index: '2' },
        //       { title: '配置选项', index: '3' },
        //       { title: '用户管理', index: '4' },
        //       { title: '日志', index: '5' }
        //     ]
        //   },
        //   {
        //     "hhh": [
        //       { title: '来玩呀', index: '1' },
        //       { title: '系统状态', index: '2' },
        //       { title: '配置选项', index: '3' },
        //       { title: '用户管理', index: '4' },
        //       { title: '日志', index: '5' }
        //     ]
        //   },
        //   {
        //     "小妹妹": [
        //       { title: '嘿嘿嘿', index: '1' },
        //       { title: '系统状态', index: '2' },
        //       { title: '配置选项', index: '3' },
        //       { title: '用户管理', index: '4' },
        //       { title: '日志', index: '5' }
        //     ]
        //   }
        // ]
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    // console.log('211111111',from)
    if (from.path === "/developmentDocking/main") {
      window.location.href = to.fullPath;
    } else {
      next();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scheduleSidebarUpdate);
    window.removeEventListener("resize", this.scheduleSidebarUpdate);
    if (this.sidebarRafId) {
      cancelAnimationFrame(this.sidebarRafId);
    }
  },
  mounted() {
    const api = this.$route.query.api || "1-0";
    const version = this.$route.query.selectedVersion || this.selectedVersion;
    this.selectedVersion = version;
    if (!this.$route.query.api) {
      this.$router.replace({
        name: "mainComponents",
        query: { api, selectedVersion: version },
      });
    }
    this.$nextTick(() => {
      this.syncMenuActive(api);
      this.updateSidebarPosition();
    });
    window.addEventListener("scroll", this.scheduleSidebarUpdate, { passive: true });
    window.addEventListener("resize", this.scheduleSidebarUpdate, { passive: true });
  },
  watch: {
    "$route.query.api"(val) {
      this.syncMenuActive(val);
    },
    "$route.query.selectedVersion"(val) {
      if (val && val !== this.selectedVersion) {
        this.selectedVersion = val;
      }
    },
  },
  computed: {
    activeMenuIndex() {
      return this.$route.query.api || "1-0";
    },
    codeLines() {
      // 将代码按行分割成数组
      return this.code.split("\n");
    },
    propList() {
      return this.menuItems[this.selectedVersion].map(
        (_, index) => `${index + 1}`,
      );
    },
    sidebarStyle() {
      return {
        top: `${this.sidebarTop}px`,
        height: `calc(100vh - ${this.sidebarTop}px)`,
      };
    },
  },
  methods: {
    getMenuIndices(version) {
      const items = this.menuItems[version] || [];
      const indices = [];
      items.forEach((item, index) => {
        (item.children || []).forEach((_, groupIndex) => {
          indices.push(`${index + 1}-${groupIndex}`);
        });
      });
      return indices;
    },
    handleVersionChange(version) {
      const indices = this.getMenuIndices(version);
      let api = this.activeMenuIndex;
      if (!indices.includes(api)) {
        api = indices[0] || "1-0";
      }
      this.handleSelect(api, [api.split("-")[0]], version);
    },
    hasMenuItemTip(itemGroup) {
      const tip = itemGroup && itemGroup.tipContent;
      return !!(tip && (tip.title || tip.api));
  },
    handleOpen(key, keyPath) {
      //  console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //  console.log(key, keyPath);
    },
    handleSelect(key, keyPath, selectType) {
      this.totalIndex = keyPath[0];
      this.syncMenuActive(key);
      const target = {
        name: "mainComponents",
        query: { api: key, selectedVersion: selectType },
      };
      const navigate = this.$router.push(target);
      if (navigate && navigate.catch) {
        navigate.catch(() => {});
      }
      this.scrollContentToTop();
    },
    syncMenuActive(index) {
      this.$nextTick(() => {
        const menu = this.$refs.sidebarMenu;
        if (menu && index) {
          menu.activeIndex = index;
        }
      });
    },
    scrollContentToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.updateSidebarPosition();
        });
      });
    },
    scheduleSidebarUpdate() {
      if (this.sidebarRafId) return;
      this.sidebarRafId = requestAnimationFrame(() => {
        this.sidebarRafId = null;
        this.updateSidebarPosition();
      });
    },
    updateSidebarPosition() {
      const navbar =
        document.getElementById("navbar") ||
        document.querySelector(".navbarHeightWhite");
      if (!navbar) {
        if (this.sidebarTop !== 0) this.sidebarTop = 0;
        return;
      }
      const bottom = Math.round(navbar.getBoundingClientRect().bottom);
      const nextTop = bottom > 0 ? bottom : 0;
      if (nextTop !== this.sidebarTop) {
        this.sidebarTop = nextTop;
      }
    },
    filteredMenuItems(val) {
      this.propList = [];
      if (val === "") {
        return this.menuItems; // 如果没有搜索查询，返回全部
      }
      const searchLower = `${val}`;
      const append = this.menuItems[this.selectedVersion].map((item, index) => {
        const eleIndex = item.children.findIndex(
          (element) => searchLower === element.title.toLowerCase(),
        );
        if (eleIndex !== -1) {
          return {
            groupIndex: index,
            itemIndex: eleIndex,
            item: item.children[eleIndex],
          };
        }
      });
      const appendData = append.filter((x) => x !== undefined);
      const index = `${appendData[0].groupIndex + 1}`;
      this.propList.push(index);
    },
  },
};
</script>
<!-- <style src="./index.css" scoped></style> -->
<style scoped lang="scss">
$scrollbar-thumb: rgba(0, 55, 123, 0.28);
$scrollbar-thumb-hover: rgba(0, 55, 123, 0.48);

@mixin panel-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: $scrollbar-thumb transparent;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $scrollbar-thumb;
    border-radius: 3px;

    &:hover {
      background-color: $scrollbar-thumb-hover;
    }
  }
}

$nav-height: 76px;

.develop-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  min-height: calc(100vh - #{$nav-height});
  background-color: #ebeef5 !important;

  .develop-sidebar {
    flex: 0 0 280px;
    width: 280px;
    align-self: flex-start;
  }

  .sidebar-inner {
    position: fixed;
    left: 0;
    z-index: 90;
    width: 280px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-top: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
    overflow: hidden;
    box-sizing: border-box !important;
    transform: translateZ(0);
    backface-visibility: hidden;
  }

  .version-inline {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e5e5;
    box-sizing: border-box;

    .version-label {
      flex-shrink: 0;
      font-size: 13px;
      color: #606266;
      white-space: nowrap;
    }

    :deep(.el-select) {
      flex: 1;
      min-width: 0;
      width: 0;
    }

    :deep(.el-input__inner) {
      padding-left: 8px;
      padding-right: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .sidebar-menu {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    border-right: none;
    background-color: #fff;
    box-sizing: border-box !important;
    @include panel-scrollbar;
  }

  :deep(.el-menu) {
    border-right: none;
    box-sizing: border-box !important;
  }

  :deep(.el-submenu .el-menu) {
    overflow: hidden;
  }

  :deep(.el-submenu__title) {
    font-size: 14px;
    color: #252525;
    padding: 0 12px;
    display: flex;
    align-items: center;
  }

  .module-icon {
    width: 18px;
    height: 18px;
    font-weight: 600;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .menu-item-icon {
    width: 18px;
    height: 18px;
    margin-right: 6px;
    flex-shrink: 0;
  }

  :deep(.el-menu-item) {
    margin: 0 6px;
    height: auto !important;
    min-height: 40px;
    line-height: 1.4;
    padding: 10px 12px !important;
    white-space: normal;
    box-sizing: border-box !important;

    .menu-item-content {
      display: flex;
      align-items: center;
      color: #686666;
      font-size: 13px;
    }

    &:hover {
      border-radius: 6px;
      background: #e9fafa !important;
    }

    &.is-active {
      border-radius: 6px;
      background: #00afaf !important;

      .menu-item-content {
        color: #fff;
      }
    }
  }

  .develop-content {
    flex: 1;
    min-width: 0;
  }

  .develop-main {
    padding-top: 8px;
    box-sizing: border-box;
  }

  :deep(.main) {
    margin: 0;
    height: auto;
    overflow: visible;
  }
  :deep(.el-submenu__icon-arrow){
    font-size: 15px;
  }
  :deep(.el-submenu__title:hover){
    background-color: #d9f3f3;
  }
  :deep(.el-input__inner){
    padding: 0 !important;
  }
}
</style>
